/* eslint-disable */
const _window_bns = typeof window !== 'undefined' ? window : {};

const Beans3 = {
  _q: [],
  _rq: [],
  _trellis: null,
  _trellis_version: null,
  isEnvProd: () => '$$APP_ENV$$' === 'PROD',
};

Beans3.DEPLOY_VERSION_HASH = '$$DEPLOY_VERSION_HASH$$';
Beans3.DEFAULT_API_NAMESPACE = 'stem';

/* Public functions */
/* The functions below return a Promise */
Beans3.get = function (...args) {
  let path,
    data,
    namespace = Beans3.DEFAULT_API_NAMESPACE;
  ({ path, data, namespace = Beans3.DEFAULT_API_NAMESPACE } = args[0]);
  return Beans3._api.exec('GET', { path, data, namespace });
};

Beans3.post = function (...args) {
  let path,
    data,
    namespace = Beans3.DEFAULT_API_NAMESPACE;
  ({ path, data, namespace = Beans3.DEFAULT_API_NAMESPACE } = args[0]);
  return Beans3._api.exec('POST', { path, data, namespace });
};

Beans3.put = function (...args) {
  let path,
    data,
    namespace = Beans3.DEFAULT_API_NAMESPACE;
  ({ path, data, namespace = Beans3.DEFAULT_API_NAMESPACE } = args[0]);
  return Beans3._api.exec('PUT', { path, data, namespace });
};

Beans3.delete = function (...args) {
  let path,
    data,
    namespace = Beans3.DEFAULT_API_NAMESPACE;
  ({ path, data, namespace = Beans3.DEFAULT_API_NAMESPACE } = args[0]);
  return Beans3._api.exec('DELETE', { path, data, namespace });
};

Beans3.require = function (appName) {
  return new Promise(function (resolve, reject) {
    if (Beans3._requirement.get(appName)) {
      return resolve(appName);
    }
    return Beans3._requirement.set_dependency(appName, resolve, reject);
  });
};

/* The functions below don't return a Promise */
Beans3.getAccountID = function () {
  try {
    let v1 = '';
    let v2 = '';
    let s1;
    let s2;
    s1 = (document.cookie.match('(^|; )beans_acc=([^;]*)') || 0)[2];
    if (s1) v1 = decodeURIComponent(s1);
    s2 = (document.cookie.match('(^|; )beans_ttl=([^;]*)') || 0)[2];
    if (s2) v2 = decodeURIComponent(s2);
    if (v1 === v2) return v1;
  } catch (e) {}
  return '';
};
Beans3.setAccountID = function (value) {
  document.cookie = `beans_acc=${encodeURIComponent(value)}; path=/`;
  document.cookie = `beans_ttl=${encodeURIComponent(value)}; expires=${new Date(
    Date.now() + 1000 * 60 * 15
  ).toUTCString()}; path=/`;
};
Beans3.setAccountToken = function (value) {
  Beans3._session.set('tka', value);
};
Beans3.init = function (args) {
  if (Beans3._api.ready) return false;
  Beans3.id = args.id || args.address || args.shop || null;
  args.domainAPI = args.domainAPI || 'api.trybeans.com';
  Beans3.domainAPI = args.domainAPI;
  Beans3._api.uri = `https://${Beans3.domainAPI}/v3/`;
  Beans3._api.trellisUri = 'https://trellis.trybeans.com/api/v4/';
  if (Beans3.id && Beans3.domainAPI) {
    Beans3._api.ready = true;
    Beans3._execQueue();
    return true;
  }
  console.error('Unable to initialize Beans: Contact the Beans Team for assistance');
  return false;
};

/* Non documented functions, use these functions at your own risk */
Beans3._execInit = function () {
  let result = false;
  let l;
  for (let i = 0; i < Beans3._q.length; i++) {
    if (Beans3._q[i][0] === 'init') {
      l = Beans3._q.splice(i, 1)[0];
      Beans3[l[0]].apply(Beans3, l.slice(1));
      i -= 1;
      result = true;
    }
  }
  return result;
};
Beans3._execQueue = function () {
  let l;
  while (Beans3._q.length > 0) {
    l = Beans3._q.shift();
    Beans3[l[0]].apply(Beans3, l.slice(1));
  }
};
Beans3._execAPIDiffer = function (method, path, data, resolve, reject) {
  return Beans3._api._exec(method, path, data, resolve, reject);
};
Beans3._api = {
  uri: null,
  trellisUri: null,
  exec(method, { path, data, namespace }) {
    return new Promise(function (resolve, reject) {
      if (!Beans3._api.ready) {
        return Beans3._q.push(['_execAPIDiffer', { method, path, data, namespace }, resolve, reject]);
      }
      return Beans3._api._exec({ method, path, data, namespace }, resolve, reject);
    });
  },
  _getURL: function (path, namespace) {
    if (namespace === 'trellis') return `${Beans3._api.trellisUri}${path}`;
    return Beans3._api.uri.replace('{namespace}', namespace) + path;
  },
  _exec({ method, path, data, namespace }, resolve, reject) {
    // Check if data exists in cache for specific endpoints
    if (Beans3._api.storage.canCache(path)) {
      const data = Beans3._api.storage.getData(path);
      if (data) return resolve(data);
    }

    let url;
    let ua;
    let body;
    let xhr;
    let auth;

    // Handle FormData differently from regular JSON data
    const isFormData = data instanceof FormData;
    body = isFormData ? data : JSON.stringify(data || {});

    url = Beans3._api._getURL(path, namespace);
    ua = {
      bindings_version: '4.0',
      lang: 'JavaScript',
      lang_version: null,
      application: window.location.hostname,
      publisher: 'Beans',
    };
    if (namespace === 'trellis') auth = Beans3.cardId;
    else auth = Beans3._session.get('tka') || Beans3.id;
    xhr = new XMLHttpRequest();
    xhr.open(method, url, true);
    xhr.timeout = 120000;
    xhr.setRequestHeader('Accept', 'application/json');
    // Only set Content-Type for non-FormData requests
    if (!isFormData) {
      xhr.setRequestHeader('Content-Type', 'application/json');
    }
    xhr.setRequestHeader('X-Beans-Client-User-Agent', JSON.stringify(ua));
    xhr.setRequestHeader('Authorization', `Basic ${btoa(`${auth}:`)}`);
    xhr.setRequestHeader('X-Riper-Merchant-Id', Beans3._cache.get('auth-merchant-id') || '');
    xhr.setRequestHeader('X-Riper-Merchant-Domain', Beans3._cache.get('auth-merchant-domain') || '');
    xhr.setRequestHeader('X-Riper-Shopper-Id', Beans3._cache.get('auth-shopper-id') || '');
    xhr.setRequestHeader('X-Riper-Shopper-Email', Beans3._cache.get('auth-shopper-email') || '');
    xhr.setRequestHeader('X-Riper-Shopper-Token', Beans3._cache.get('auth-shopper-token') || '');
    xhr.onload = function () {
      let data = {};

      if (xhr.status >= 400) {
        data.error = { code: xhr.status, message: `HTTP Status ${xhr.status}` };

        if (xhr.responseText) {
          data = { ...data, ...JSON.parse(xhr.responseText) };
        }

        if (data.error.code === 401) {
          if (namespace === 'stem') Beans3.setAccountToken('');
        }

        return reject(data);
      }

      if (xhr.responseText) {
        data = JSON.parse(xhr.responseText);
        Beans3._api.storage.setData(path, data);
        resolve(data);
      } else {
        resolve();
      }
    };
    xhr.onerror = function () {
      console.error(`[Beans API] Connection Error${xhr.statusText}`);
      reject({ response: null, error: { code: null, message: null } });
    };
    xhr.send(body);
  },
  storage: {
    _prefix: 'BNS',
    _engine: _window_bns.sessionStorage,
    canCache(path) {
      return /(display\/current|ecm|lattice\/current|templet|templet_type|account\/current\/reward|\/discount\/\?purpose\=referral\&usage_count\=0\&force\=0)/.test(
        path
      );
    },
    getData(key) {
      const now = new Date();
      const item_key = `${this._prefix}-${Beans3.id}-${key}`;
      const data_str = this._engine.getItem(item_key);
      if (data_str == null || data_str === 'undefined') return null;
      const data = JSON.parse(data_str);
      if (!data.__expiry || data.__expiry < now.getTime()) {
        this._engine.removeItem(item_key);
        return null;
      }
      return data;
    },
    setData(key, value) {
      const now = new Date();
      const item_key = `${this._prefix}-${Beans3.id}-${key}`;
      value.__expiry = now.getTime() + 5 * 60 * 1000;
      return this._engine.setItem(item_key, JSON.stringify(value));
    },
    clear: function clear() {
      this._engine.clear();
    },
  },
};
Beans3._utils = {
  isBrowserSupported() {
    if (typeof Promise === 'function') return true;
    console.error('Unable to initialize Beans: Browser not supported');
    return false;
  },
  isMobile() {
    return (
      (window.innerWidth || document.documentElement.offsetWidth) < 490 &&
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    );
  },
  loadCSS(id, href) {
    if (!document.getElementById(id)) {
      const head = document.getElementsByTagName('head')[0];
      const link = document.createElement('link');
      link.id = id;
      link.rel = 'stylesheet';
      link.type = 'text/css';
      link.href = href;
      link.media = 'all';
      head.appendChild(link);
    }
  },
  copyToClipboard(text) {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
      document.execCommand('copy');
    } catch (err) {}
    document.body.removeChild(textArea);
  },
  getCurrentScriptArgs() {
    let src = document.currentScript?.src;
    if (!src) return {};

    // quick temporary? fix for CR-183:
    // parsing: /ultimate.beans.js?radix=woocommerce#038;id=card_0wewdf8b&#038;siteground-async=1&#038;ver=1634144457
    src = src.replace(/\&?\#038\;/g, '&');

    const pa = src.split('?').pop().split('&');
    const p = {};
    for (let j = 0; j < pa.length; j++) {
      const kv = pa[j].split('=');
      p[kv[0]] = kv[1];
    }
    return p;
  },
  getOrCreateContainer(target, className) {
    const elements = document.getElementsByClassName(className);
    if (elements.length) return elements[0];
    const c0 = document.createElement('div');
    c0.className += className;
    target.appendChild(c0);
    return c0;
  },
  getCookie(name) {
    const cookie = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`)?.pop() || '';
    return JSON.parse(decodeURIComponent(cookie));
  },
};
Beans3.previewSession = {
  key: 'is_beans_preview_session',
  isActive() {
    if (localStorage.getItem(this.key) === 'true') return true;
    // https://stackoverflow.com/a/901144
    const queryParams = new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop) => searchParams.get(prop),
    });
    const beansMode = queryParams['beans-mode'];
    const hash = window.location.hash;

    if ((hash && hash.includes('#beans_preview_mode')) || beansMode === 'preview') {
      localStorage.setItem(this.key, 'true');
      return true;
    }
    return false;
  },
  exit() {
    localStorage.removeItem(this.key);
    const currentURL = new URL(window.location);
    currentURL.search = '';
    currentURL.hash = '';
    window.history.pushState({}, '', currentURL);
    window.location.reload();
  },
};
Beans3._cache = {
  _cache: (function (w) {
    w.Beans3__Cache = w.Beans3__Cache || {};
    return w.Beans3__Cache;
  })(_window_bns),
  set(key, value) {
    this._cache[key] = value;
  },
  get(key) {
    return this._cache[key];
  },
};
Beans3._session = {
  _session: null,
  _cookie: 'beans_session',
  get(key) {
    if (!this._session) this._load();
    return this._session[key];
  },
  set(key, value) {
    if (!this._session) this._load();
    this._session[key] = value;
    this._save();
  },
  destroy() {
    const n = this._cookie;
    document.cookie = `${n}=; expires=${new Date(Date.now() - 1).toUTCString()}; path=/`;
    this._session = {};
  },
  _save() {
    const n = this._cookie;
    const v = encodeURIComponent(JSON.stringify(this._session));
    const d = 1;
    document.cookie = `${n}=${v}; expires=${new Date(Date.now() + 86400000 * d).toUTCString()}; path=/`;
  },
  _load() {
    const c = Beans3._cache.get('session');
    const s = (document.cookie.match(`(^|; )${this._cookie}=([^;]*)`) || 0)[2];
    if (c) {
      this._session = c;
    } else if (s) {
      this._session = JSON.parse(decodeURIComponent(s));
    } else {
      this._session = {};
    }
    Beans3._cache.set('session', this._session);
  },
};
Beans3._requirement = {
  set(appName) {
    const r = Beans3._cache.get('requirements') || {};
    r[appName] = true;
    Beans3._cache.set('requirements', r);
    this._exec_dependency(appName);
  },
  get(appName) {
    const r = Beans3._cache.get('requirements') || {};
    return r[appName] || false;
  },
  set_dependency(appName, resolve, reject) {
    const d = Beans3._cache.get('dependencies') || [];
    d.push([appName, resolve, reject]);
    Beans3._cache.set('dependencies', d);
  },
  _exec_dependency(appName) {
    const d = Beans3._cache.get('dependencies') || [];
    let result = false;
    for (let i = 0; i < d.length; i++) {
      if (d[i][0] === appName) {
        d[i][1](appName);
        result = true;
      }
    }
    return result;
  },
};

/* Launch Beans3 Async */
Beans3.loaded = true;
Beans3._execInit();

export default Beans3;
